<template>
  <div data-testid="pickup-schedule-config-shipment-skeleton" class="w-full">
    <div class="w-full bg-white rounded-xl card-border p-4">
      <Skeleton height="20px" width="160px" />
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
        <div v-for="field in 2" :key="field" class="space-y-2">
          <Skeleton height="14px" width="140px" />
          <Skeleton height="36px" width="100%" />
        </div>
        <div class="space-y-2 lg:col-span-2">
          <Skeleton height="14px" width="140px" />
          <Skeleton height="36px" width="100%" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card-border {
  border: 1px solid #e6e6e6;
}
</style>
